import { useRef } from "react";
import "./Shop.css";
import "./ShopResponsive.css";

function Shop() {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <>
      <div className="shop-frame-wrapper">
        <iframe
          ref={iframeRef}
          src="https://paystack.shop/standout-fresh-produce"
          title="Standout Fresh Produce e-commerce"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          onLoad={(e: any) => {
            console.log("e.contentWindow");
          }}
          onLoadedMetadata={() => {
            console.log("first")
          }}
        ></iframe>
      </div>
    </>
  );
}

export default Shop;
